<template>
  <ContentLayout
    :title="$t('label_essweb_approvalTemplate_list_title')"
    :addBtn="hasBtn('add-admin-approval-template')"
    pad="0"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :showSelect="showSelect"
        :filter-page-data="filterPageData"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            style="max-width: 400px !important"
            :title="$getCommonLangValue(item.flow_template_name)"
          >
            {{ $getCommonLangValue(item.flow_template_name) }}
          </div>
          <!-- <div class="text--secondary table-subtitle">
            {{ $getCommonLangValue(item.flow_template_description) }}
          </div> -->
        </template>
        <template v-slot:item.type="{ item }">
          {{ $getCommonLangValue(item.flow_type_name) }}
        </template>
        <template v-slot:item.status="{ item }">
          <StatusChip
            icon
            :show-icon="false"
            text-color="white--text"
            :bgColor="Number(item.flow_template_status) ? 'green' : 'grey'"
          >
            <template v-slot:status>
              {{
                Number(item.flow_template_status)
                  ? $t("label_essweb_system_status_onLabel")
                  : $t("label_essweb_system_status_offLabel")
              }}
            </template>
          </StatusChip>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :delBtn="hasBtn('delete-admin-approval-template')"
            :editBtn="hasBtn('edit-admin-approval-template')"
            :viewBtn="hasBtn('view-admin-approval-template')"
            :uuid="item.uuid"
            :title="$t('label_essweb_approvalTemplate_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ApprovalLibray",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  data() {
    return {
      showDelete: false,
      totalCount: 0,
      showAllDelete: false,
      headers: [
        {
          text: "label_essweb_approvalTemplate_list_approvalTemplateNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.flow_template_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_approvalTemplate_list_approvalTemplateStatusLabel",
          value: "status",
          align: "start",
          width: 120,
          sortable: false,
        },
        {
          text: "label_essweb_approvalTemplate_list_approvalTemplateTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      page: 1,
      search: "",
      showSelect: false,
      desserts: [],
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_approvalTemplate_list_approvalTemplateNameLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "flow_type_name",
          name: "flow_type",
          multiple: true,
          label: "label_essweb_approvalTemplate_list_approvalTemplateTypeLabel",
          value: [],

          selected: [],
          data: {
            api: "/approval-type/get-approval-type-list/",
            url_type: "primary",
            args: null,
            table: "ess_workflow_flow_type",
            type: "",
            modelKey: "flow_type_name",
            valueKey: "uuid",
            global: false,
          },
        },
      ],
      filterPageData: null,
    };
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name") {
          data["flow_template_name"] = item.value;
        }
        if (item["name"] == "flow_type") {
          data["flow_type_uuid"] = item.value.join(",");
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    toNew: function () {
      this.$toPage("/admin/approval-template/add", {});
    },
    toDelete: function (uuid) {
      const that = this;
      this.showDelete = false;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/delete-approval-template-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_approvalTemplate_deleteApprovalSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/approval-template/edit/"
          : "/admin/approval-template/detail/") + uuid
      );
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/get-approval-template-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    tableToolsChange: function (val) {
      this.showAllDelete = val;
    },
  },
};
</script>
